// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__380lB","empty":"ModalGraph_empty__3c3bC"};